export  const academy=[
    {
        heading: "Critical Thinking and Problem Solving in Today’s C...",
        short: "Short Course",
        length: "4",
        hour: "1:57 hours",
        detail: "For great inbound marketers, thinking critically is the key to better probl...",
        href: "https://academy.hubspot.com/courses/critical_thinking?library=true&",
        "hsg-sr-only": "Critical Thinking and Problem Solving in Today’s Changing Workplace Course",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1056124",
        "hsg-ribbon": "",
        "isvg": "",
        "isvg 2": ""
    },
    {
        heading: "Inbound Marketing Optimization",
        short: "Certification Course",
        length: "7",
        hour: "3:24 hours",
        detail: "You've aligned your marketing strategy around your customer, so what's next...",
        href: "https://academy.hubspot.com/courses/inbound-marketing-optimization?library=true&",
        "hsg-sr-only": "Inbound Marketing Optimization",
        button: "Start certification",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1045124",
        "hsg-ribbon": "new",
        "isvg": "Icons/Utilities/Certification+hat",
        "isvg 2": "Created with Sketch."
    },
    {
        heading: "HubSpot CMS Best Practices for Developers",
        short: "Short Course",
        length: "4",
        hour: "1:33 hours",
        detail: "As a web developer, you're responsible for creating websites that delight y...",
        href: "https://academy.hubspot.com/courses/cms-best-practices-for-developers?library=true&",
        "hsg-sr-only": "HubSpot CMS Best Practices for Developers",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1044124",
        "hsg-ribbon": "",
        "isvg": "",
        "isvg 2": ""
    },
    {
        heading: "Inbound Marketing",
        short: "Certification Course",
        length: "7",
        hour: "3:38 hours",
        detail: "Learn about inbound marketing techniques and develop an understanding of th...",
        href: "https://academy.hubspot.com/courses/inbound-marketing?library=true&",
        "hsg-sr-only": "Inbound Marketing",
        button: "Start certification",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1028124",
        "hsg-ribbon": "popular",
        "isvg": "Icons/Utilities/Certification+hat",
        "isvg 2": "Created with Sketch."
    },
    {
        heading: "Delivering Exceptional Customer Support",
        short: "Short Course",
        length: "4",
        hour: "45 minutes",
        detail: "Delivering exceptional customer support means you're creating value for you...",
        href: "https://academy.hubspot.com/courses/delivering-exceptional-customer-support?library=true&",
        "hsg-sr-only": "Delivering Exceptional Customer Support",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1015124",
        "hsg-ribbon": "",
        "isvg": "",
        "isvg 2": ""
    },
    {
        heading: "Building a Website in CMS Hub Starter",
        short: "Short Course",
        length: "3",
        hour: "36 minutes",
        detail: "Learn how to design and create a user-friendly, high-performing website wit...",
        href: "https://academy.hubspot.com/courses/cms-hub-starter-training?library=true&",
        "hsg-sr-only": "Building a Website in CMS Hub Starter",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1011126",
        "hsg-ribbon": "",
        "isvg": "",
        "isvg 2": ""
    },
    {
        heading: "LinkedIn Marketing for Business",
        short: "Short Course",
        length: "3",
        hour: "1:21 hours",
        detail: "LinkedIn is the de-facto social platform for business professionals who are...",
        href: "https://academy.hubspot.com/courses/linkedin-marketing?library=true&",
        "hsg-sr-only": "LinkedIn Marketing for Business",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1011125",
        "hsg-ribbon": "new",
        "isvg": "",
        "isvg 2": ""
    },
    {
        heading: "Revenue Operations",
        short: "Certification Course",
        length: "9",
        hour: "6:17 hours",
        detail: "Revenue Operation (RevOps) is key to helping your company achieve scale. If...",
        href: "https://academy.hubspot.com/courses/revenue-operations?library=true&",
        "hsg-sr-only": "Revenue Operations",
        button: "Start certification",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1011124",
        "hsg-ribbon": "new",
        "isvg": "Icons/Utilities/Certification+hat",
        "isvg 2": "Created with Sketch."
    },
    {
        heading: "Service Hub Admin: Setting up Service Hub for Succ...",
        short: "Short Course",
        length: "5",
        hour: "1:10 hours",
        detail: "This course is intended to help admins set up their Service Hub Professiona...",
        href: "https://academy.hubspot.com/courses/service-hub-admin?library=true&",
        "hsg-sr-only": "Service Hub Admin: Setting up Service Hub for Success",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1003125",
        "hsg-ribbon": "",
        "isvg": "",
        "isvg 2": ""
    },
    {
        heading: "HubSpot CMS for Developers",
        short: "Certification Course",
        length: "7",
        hour: "3:04 hours",
        detail: "This track contains lessons and resources to help web developers learn how ...",
        href: "https://academy.hubspot.com/courses/cms-for-developers?library=true&",
        "hsg-sr-only": "HubSpot CMS for Developers",
        button: "Start certification",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=121",
        "hsg-ribbon": "new",
        "isvg": "Icons/Utilities/Certification+hat",
        "isvg 2": "Created with Sketch."
    },
    {
        heading: "Excel for Marketers",
        short: "Short Course",
        length: "3",
        hour: "1:13 hours",
        detail: "As a marketer, you are likely using multiple systems to manage your data, i...",
        href: "https://academy.hubspot.com/courses/excel-training-crash-course?library=true&",
        "hsg-sr-only": "Excel for Marketers",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=119",
        "hsg-ribbon": "new",
        "isvg": "",
        "isvg 2": ""
    },
    {
        heading: "Designing Effective Google Ads Campaigns",
        short: "Short Course",
        length: "4",
        hour: "1:48 hours",
        detail: "Google Ads is an effective way to drive qualified traffic, or good-fit cust...",
        href: "https://academy.hubspot.com/courses/designing-google-ads?library=true&",
        "hsg-sr-only": "Designing Effective Google Ads Campaigns",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=118",
        "hsg-ribbon": "",
        "isvg": "",
        "isvg 2": ""
    } ,
     {
        heading: "Critical Thinking and Problem Solving in Today’s C...",
        short: "Short Course",
        length: "4",
        hour: "1:57 hours",
        detail: "For great inbound marketers, thinking critically is the key to better probl...",
        href: "https://academy.hubspot.com/courses/critical_thinking?library=true&",
        "hsg-sr-only": "Critical Thinking and Problem Solving in Today’s Changing Workplace Course",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1056124",
        "hsg-ribbon": "",
        "isvg": "",
        "isvg 2": ""
    },
    {
        heading: "Inbound Marketing Optimization",
        short: "Certification Course",
        length: "7",
        hour: "3:24 hours",
        detail: "You've aligned your marketing strategy around your customer, so what's next...",
        href: "https://academy.hubspot.com/courses/inbound-marketing-optimization?library=true&",
        "hsg-sr-only": "Inbound Marketing Optimization",
        button: "Start certification",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1045124",
        "hsg-ribbon": "new",
        "isvg": "Icons/Utilities/Certification+hat",
        "isvg 2": "Created with Sketch."
    },
    {
        heading: "HubSpot CMS Best Practices for Developers",
        short: "Short Course",
        length: "4",
        hour: "1:33 hours",
        detail: "As a web developer, you're responsible for creating websites that delight y...",
        href: "https://academy.hubspot.com/courses/cms-best-practices-for-developers?library=true&",
        "hsg-sr-only": "HubSpot CMS Best Practices for Developers",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1044124",
        "hsg-ribbon": "",
        "isvg": "",
        "isvg 2": ""
    },
    {
        heading: "Inbound Marketing",
        short: "Certification Course",
        length: "7",
        hour: "3:38 hours",
        detail: "Learn about inbound marketing techniques and develop an understanding of th...",
        href: "https://academy.hubspot.com/courses/inbound-marketing?library=true&",
        "hsg-sr-only": "Inbound Marketing",
        button: "Start certification",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1028124",
        "hsg-ribbon": "popular",
        "isvg": "Icons/Utilities/Certification+hat",
        "isvg 2": "Created with Sketch."
    },
    {
        heading: "Delivering Exceptional Customer Support",
        short: "Short Course",
        length: "4",
        hour: "45 minutes",
        detail: "Delivering exceptional customer support means you're creating value for you...",
        href: "https://academy.hubspot.com/courses/delivering-exceptional-customer-support?library=true&",
        "hsg-sr-only": "Delivering Exceptional Customer Support",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1015124",
        "hsg-ribbon": "",
        "isvg": "",
        "isvg 2": ""
    },
    {
        heading: "Building a Website in CMS Hub Starter",
        short: "Short Course",
        length: "3",
        hour: "36 minutes",
        detail: "Learn how to design and create a user-friendly, high-performing website wit...",
        href: "https://academy.hubspot.com/courses/cms-hub-starter-training?library=true&",
        "hsg-sr-only": "Building a Website in CMS Hub Starter",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1011126",
        "hsg-ribbon": "",
        "isvg": "",
        "isvg 2": ""
    },
    {
        heading: "LinkedIn Marketing for Business",
        short: "Short Course",
        length: "3",
        hour: "1:21 hours",
        detail: "LinkedIn is the de-facto social platform for business professionals who are...",
        href: "https://academy.hubspot.com/courses/linkedin-marketing?library=true&",
        "hsg-sr-only": "LinkedIn Marketing for Business",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1011125",
        "hsg-ribbon": "new",
        "isvg": "",
        "isvg 2": ""
    },
    {
        heading: "Revenue Operations",
        short: "Certification Course",
        length: "9",
        hour: "6:17 hours",
        detail: "Revenue Operation (RevOps) is key to helping your company achieve scale. If...",
        href: "https://academy.hubspot.com/courses/revenue-operations?library=true&",
        "hsg-sr-only": "Revenue Operations",
        button: "Start certification",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1011124",
        "hsg-ribbon": "new",
        "isvg": "Icons/Utilities/Certification+hat",
        "isvg 2": "Created with Sketch."
    },
    {
        heading: "Service Hub Admin: Setting up Service Hub for Succ...",
        short: "Short Course",
        length: "5",
        hour: "1:10 hours",
        detail: "This course is intended to help admins set up their Service Hub Professiona...",
        href: "https://academy.hubspot.com/courses/service-hub-admin?library=true&",
        "hsg-sr-only": "Service Hub Admin: Setting up Service Hub for Success",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=1003125",
        "hsg-ribbon": "",
        "isvg": "",
        "isvg 2": ""
    },
    {
        heading: "HubSpot CMS for Developers",
        short: "Certification Course",
        length: "7",
        hour: "3:04 hours",
        detail: "This track contains lessons and resources to help web developers learn how ...",
        href: "https://academy.hubspot.com/courses/cms-for-developers?library=true&",
        "hsg-sr-only": "HubSpot CMS for Developers",
        button: "Start certification",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=121",
        "hsg-ribbon": "new",
        "isvg": "Icons/Utilities/Certification+hat",
        "isvg 2": "Created with Sketch."
    },
    {
        heading: "Excel for Marketers",
        short: "Short Course",
        length: "3",
        hour: "1:13 hours",
        detail: "As a marketer, you are likely using multiple systems to manage your data, i...",
        href: "https://academy.hubspot.com/courses/excel-training-crash-course?library=true&",
        "hsg-sr-only": "Excel for Marketers",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=119",
        "hsg-ribbon": "new",
        "isvg": "",
        "isvg 2": ""
    },
    {
        heading: "Designing Effective Google Ads Campaigns",
        short: "Short Course",
        length: "4",
        hour: "1:48 hours",
        detail: "Google Ads is an effective way to drive qualified traffic, or good-fit cust...",
        href: "https://academy.hubspot.com/courses/designing-google-ads?library=true&",
        "hsg-sr-only": "Designing Effective Google Ads Campaigns",
        button: "Start course",
        buttonhref: "https://app.hubspot.com/signup-hubspot/academy?hubs_signup-url=academy.hubspot.com/courses&lang=en&&intent=academyTrack&track=118",
        "hsg-ribbon": "",
        "isvg": "",
        "isvg 2": ""
    }
]

export const bot=[
  {head:"Advance your career",lorem:"Invest in yourself and your career by staying up to date on the latest trends in digital marketing, sales, customer support, and more."},
  {head:"Show off your skills",lorem:"Add a globally recognized certification to your LinkedIn profile to show your employer — or future employer — you know your stuff."},
  {head:"Grow your business ",lorem:"Build your business strategy on the inbound methodology to generate more leads, close more deals, and delight your customers."}
]